import React from "react";

interface IArrowProps {
  className?: string;
}

const ArrowRight = ({ className = "" }: IArrowProps) => (
  <svg
    className={className}
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.15406 9.48857L7.15409 9.48861C7.38328 9.75407 7.78223 9.78178 8.04714 9.55306L8.04716 9.55305L12.903 5.35888C12.903 5.35885 12.9031 5.35883 12.9031 5.35881C13.0418 5.23983 13.1208 5.06667 13.1225 4.88566L13.1225 4.88566L13.1225 4.88475L13.1225 4.88059C13.1225 4.69946 13.0451 4.52796 12.9113 4.40906C12.9113 4.40905 12.9113 4.40904 12.9113 4.40903L9.74804 1.58844L9.74815 1.58831L9.74355 1.58466L8.08715 0.273708C8.08711 0.273677 8.08707 0.273645 8.08703 0.273614C7.81167 0.0544189 7.41426 0.102757 7.19711 0.375852C6.97958 0.649407 7.02555 1.04836 7.3009 1.26449C7.30096 1.26453 7.30101 1.26458 7.30107 1.26462L8.9315 2.55288L10.8785 4.28956L1.29539 4.28956C0.946019 4.28956 0.662603 4.57298 0.662603 4.92235C0.662603 5.27171 0.946019 5.55513 1.29539 5.55513L10.739 5.55648L7.21997 8.59692C6.95618 8.82444 6.9265 9.22474 7.15406 9.48857Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
  </svg>
);

export default ArrowRight;
